import React from 'react';

function About () {
	return <div>
		<h1> About us page</h1>
	</div>
}
export default About;
